import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  constructor() {}
  urlApiManagement = environment.urlApiManagement;

  logout() {
    if (!localStorage.getItem('mlct')) {
      window.location.href = '/login';
    }
    window.location.href = '/login';
  }
}
